<template>
  <div class="req-report-team-loader">
    <WidgetHeaderSkeleton />
    <div class="mt-4">
      <div v-for="listItem in numberOfItems" :key="listItem" class="team-item">
        <v-skeleton-loader type="heading" width="100" class="mb-1" />
        <v-skeleton-loader type="heading" width="120" />
      </div>
      <v-skeleton-loader type="heading" width="130" class="bottom-item mt-3" />
    </div>
  </div>
</template>

<script setup>
import WidgetHeaderSkeleton from '@/components/insights/skeletonLoaders/WidgetHeaderSkeleton.vue';

defineProps({
  numberOfItems: {
    type: Number,
    default: 5,
  },
});
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader__heading) {
  margin: 0px;
  height: 20px;
}

:deep(.v-skeleton-loader__text) {
  margin: 0px;
}

.req-report-team-loader {
  background: @white;
  border-radius: 10px;
  padding: 24px;
}

.team-item {
  padding: 12px 0;
  border-bottom: 1px solid @stroke-default;
}
</style>
